import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="onboarding--verify-emails-intent"
export default class extends Controller {
  static targets = ["option", "continueButton"]

  connect() {
    this.updateContinueButtonState()
  }

  updateContinueButtonState() {
    const checkedOption = this.optionTargets.find((option) => option.checked)

    if (checkedOption) {
      this.continueButtonTarget.href = checkedOption.dataset.targetPath
      this.continueButtonTarget.classList.remove("disabled")
      this.continueButtonTarget.disabled = false // Ensure button is actually enabled
    } else {
      this.continueButtonTarget.href = "#"
      this.continueButtonTarget.classList.add("disabled")
      this.continueButtonTarget.disabled = true // Ensure button is disabled
    }
  }
}
